export const SUBMIT_STATUS = 'timeAndAttendance@submit-status';
export const GET_STATUS = 'timeAndAttendance@get-status';
export const GET_ATTENDANCE = 'timeAndAttendance@get-attendance';
export const GET_WEEKLY_STATUS = 'timeAndAttendance@get-weekly-status';
export const CREATE_ATTENDANCE = 'timeAndAttendance@create-attendance';
